import MagnaLogo from '../../../assets/img/Magna-green.png';

const AdvertisementEmptyState = () => (
    <div className="advertisement-empty-state">
        <div className="advertisement-glow" />

        <img
            src={MagnaLogo}
            alt="Magna Cash & Carry"
            className="advertisement-logo"
        />
    </div>
);

export default AdvertisementEmptyState;
